export default {
    namespaced: true,
    state: {
        data: null
    },
    getters: {
        data(state) {
            return state.data;
        },
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        }
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        use({ commit }, data) {
            this.getters["socket"].emit("use_inv_item", {
                id: data.id,
                amount: data.amount
            }, () => {
                //loader.hide();
            });
        },
    }
};